// extracted by mini-css-extract-plugin
export default {"map-container":"WorldColoredMap_map-container__M9Hf7","popup":"WorldColoredMap_popup__ODgBJ","title":"WorldColoredMap_title__q4NPq","icon":"WorldColoredMap_icon__ajLvA"};